import { ILesdag } from '@/interfaces/ILesdag'
import { IEventAfspraak, ILesdagSpeciaal } from '@/interfaces/ILesdagSpeciaal'
import axios, { AxiosResponse } from 'axios'

export default class LesdagenService {
    getLesdagen(stamgroepId: number, datum: string): Promise<AxiosResponse<ILesdag[]>> {
        return axios.get(`/api/Frontend/Planning/JouwLesdag/${stamgroepId}/${datum}`)
    }

    getAfspraakDetails(stamgroepId: number, afspraakId: number): Promise<AxiosResponse<IEventAfspraak>> {
        return axios.get(`/api/Frontend/Planning/JouwLesdag/afspraakDetails/${stamgroepId}/${afspraakId}`)
    }

    getLesdagenSpeciaal(stamgroepId: number, datum: string): Promise<AxiosResponse<ILesdagSpeciaal>> {
        return axios.get(`/api/Frontend/Planning/JouwLesdag/speciaal/${stamgroepId}/${datum}`)
    }
}

export const yourDayService: LesdagenService = new LesdagenService()
